import { NgClass, NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { MyuiComponent } from '../abstract/abstract.component';

@Component({
  selector: 'myui-label',
  imports: [NgClass, NgStyle],
  templateUrl: 'label.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MyuiLabel extends MyuiComponent {
  public override mSelector = 'myui-label';

  public for = input<string | undefined>();
  public label = input<string | undefined>();
}
